export default __webpack_public_path__ + "static/stanimira-vlaeva-52bf98362c580c8dea47e7a8d51a4543.jpg";